import { isEditing } from "@/utils/islands";
import './login-state.css';
import {authStorageKey, hasValidToken} from "@sitecorecomponents/Users/Store/tokenstore";

const body = document.querySelector('body');

export const loginStateChangedEvent = 'login-state-changed';

export function refreshLoginState() {

  // Auth state must never land on <body> in the editor - login-state.css would
  // then hide half the markup the editor is meant to be editing.
  if (!body || isEditing()) {
    return;
  }

  const value = hasValidToken();

  body.classList.toggle('user-authenticated', value)
  body.classList.toggle('user-not-authenticated', !value)
  globalThis.dispatchEvent(new Event(loginStateChangedEvent));
}

export function whenLoggedIn(): Promise<void> {
  return new Promise(resolve => {
    const check = () => {
      if (hasValidToken()) {
        globalThis.removeEventListener(loginStateChangedEvent, check);
        resolve();
      }
    };
    globalThis.addEventListener(loginStateChangedEvent, check);
    check();
  });
}

export default function () {
  // The session is shared across tabs, so logging in or out in one of them
  // leaves every other tab's body classes showing the previous answer.
  globalThis.addEventListener('storage', evt => {
    if (evt.key === authStorageKey) {
      refreshLoginState();
    }
  });

  refreshLoginState();
}
